import { useAppSelector } from "hooks/redux";

export default function useCurrencyFacility() {
  const { facilityStore } = useAppSelector(store => store);
  function displayCurrency(amount: number | string, currency?: string) {
    const defaultCurrency = currency ?? facilityStore?.facility?.default_currency_code;
    const format = new Intl.NumberFormat(new Intl.NumberFormat().resolvedOptions().locale ?? "en-CA", {
      style: "currency",
      currency: defaultCurrency?.toUpperCase() ?? "CAD",
      useGrouping: false,
    }).format(Number(amount));
    return format.replace(/[A-Za-z ]/g, "");
  }

  function getCurrencySymbol(currency: string) {
    const symbol = new Intl.NumberFormat(new Intl.NumberFormat().resolvedOptions().locale ?? "en-CA", {
      style: "currency",
      currency: currency?.toUpperCase() ?? "CAD",
    })
      .formatToParts()
      .filter(part => part.type === "currency");
    //Remove country code
    const formattedSymbol = symbol[0]?.value ? symbol[0]?.value?.replace(/[A-Za-z ]/g, "") : "$";
    return formattedSymbol;
  }

  return {
    displayCurrency,
    getCurrencySymbol,
  };
}
